import { FileQuestion } from "lucide-react"
import React from "react"
import Layout from "../components/Layout"
import { Button } from "../components/ui"

const NotFound: React.FC = () => {
    return (
        <Layout title="Página Não Encontrada">
            <div className="flex flex-col items-center gap-4 py-12 text-center">
                <FileQuestion className="h-16 w-16 text-danger-text" />
                <p className="text-muted">
                    A página que você está procurando não existe.
                </p>
                <Button onClick={() => (window.location.href = "/")}>
                    Voltar ao início
                </Button>
            </div>
        </Layout>
    )
}

export default NotFound
